<template>
  <instructions-table-dialog
    :instructions="instructions"
    :tagCategories="tagCategories"
    :text="`${text} ${(instructions && instructions.length) || (variables ? 0 : '')}`"
    :title="title"
    :loading="$apollo.loading"
  />
</template>

<script>
import InstructionsTableDialog from "@/components/instruction/InstructionsTableDialog";

import TagCategoriesQuery from "@/graphql/TagCategories.gql";
import InstructionsByTagIdsQuery from "@/graphql/queries/instruction/InstructionsByTagIds.gql";

export default {
  props: {
    title: String,
    text: String,
    variables: Object,
  },
  components: {
    InstructionsTableDialog,
  },
  apollo: {
    instructions: {
      query() {
        if (this.variables && this.variables.tagIds) {
          return InstructionsByTagIdsQuery;
        }
      },
      variables() {
        return this.variables;
      },
      skip() {
        return !this.tagCategories || !this.variables;
      },
    },

    tagCategories: {
      query: TagCategoriesQuery,
    },
  },
};
</script>
